<template>
  <div class="bg-white m-0">
    <CContainer>
      <CRow>
        <CCol sm="12">
          <div class="custom-40px-600 text-center mt-5">MYHR</div>
          <div class="text-center">
          <label class="m-3 font-color-171717"
            >About Us</label
          >

          <label class="m-3 font-color-171717"
            >Products</label
          >

          <label class="m-3 font-color-171717"
            >Services</label
          >

          <label class="m-3 font-color-171717"
            >Contact</label
          >

          <label class="m-3 font-color-171717"
            >FAQ</label
          >
        </div>
          <br />
       
         
        </CCol>

     
      
      </CRow>
    </CContainer>
    <hr />
    <CRow>
      <CCol sm="6"><label class="m-3 font-color-171717">© 2023 MYHR. All rights reserved.</label></CCol>
      <CCol sm="6">
        <div class="text-right"><label class="m-3 font-color-171717"
            >Privacy Policy</label
          >

          <label class="m-3 font-color-171717"  @click="GoToLegal()"
            >Terms and Conditions</label
          >

          <label class="m-3 font-color-171717"
            >Cookie Policy</label
          >
        </div> </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: "TheFooter",
  data() {
    return {
    
    };
  },
  methods: {
    GoToAbout() {
      this.$router.push("About");
    },
    GoToContact() {
      this.$router.push("ContactUs");
    },
    GoToLegal() {
      this.$router.push("Legal");
    },
    GoToBlog() {
      this.$router.push("Blog");
    },
    GoToLegal() {
      this.$router.push("Legal");
    },
    GoToLinkedIn() {
      window.open("https://www.linkedin.com/company/70999536/");
    },
    GoToFacebook() {
      window.open("https://www.facebook.com/pickiddo");
    },
    GoToInstagram() {
      window.open("https://www.instagram.com/pickiddo");
    },
    GoToTiktok() {
      window.open("https://www.tiktok.com/@pickiddo");
    },
    GoToYoutube() {
      window.open("https://www.youtube.com/@pickiddo");
    },
    GoToWhatsapp()
    {
      window.open("https://wa.me/600106597700");
    },

    changeImageSrc() {
      // Change image source to hover image source
      this.imageSrc = this.hoverImageSrc;
    },
    resetImageSrc() {
      // Reset image source to original image source
    },
    changeImageSrcInsta() {
      // Change image source to hover image source
      this.imageSrcInsta = this.hoverImageSrcInsta;
    },
    resetImageSrcInsta() {
      // Reset image source to original image source
    },
    changeImageSrcFb() {
      // Change image source to hover image source
      this.imageSrcFb = this.hoverImageSrcFb;
    },
    resetImageSrcFb() {
      // Reset image source to original image source
    },
    changeImageSrcLn() {
      // Change image source to hover image source
      this.imageSrcLn = this.hoverImageSrcLn;
    },
    resetImageSrcLn() {
      // Reset image source to original image source
    },
    changeImageSrcWs() {
      // Change image source to hover image source
      this.imageSrcWs = this.hoverImageSrcWs;
    },
    resetImageSrcWs() {
      // Reset image source to original image source
    },
    changeImageSrcYou() {
      // Change image source to hover image source
      this.imageSrcYou = this.hoverImageSrcYou;
    },
    resetImageSrcYou() {
      // Reset image source to original image source
    },
  },
};
</script>
<style>

.pointer:hover {
  cursor: pointer;
  text-decoration: underline;
}
.hover-pointer1 {
  cursor: pointer; /* Set cursor to pointer on hover */
}
.hover-pointer2 {
  cursor: pointer; /* Set cursor to pointer on hover */
}
.hover-pointer3 {
  cursor: pointer; /* Set cursor to pointer on hover */
}
.hover-pointer4 {
  cursor: pointer; /* Set cursor to pointer on hover */
}
.hover-pointer5 {
  cursor: pointer; /* Set cursor to pointer on hover */
}
.hover-pointer6 {
  cursor: pointer; /* Set cursor to pointer on hover */
}
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
</style>
  

